/**
 * Created by RKL on 21/08/2015.
 */
define('customersMainRouter',[
  'require',
  'exports',
  'module',
  'logger',
  'underscore',
  'marionette',
  'app',
  'customersTabs',
  'itemPagesNameMixin'
], function(
  require,
  exports,
  module,
  Logger,
  _,
  Marionette,
  App,
  CustomersTabs,
  ItemPagesNameMixin
) {
  'use strict';

  var CustomersRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'customers(/:id)(/:tab)(/:secId)(/:reload)': 'showView',
      'customers/:id/contacts/:secId/details/:tabName' : 'showContactsDetailsShow',
      'customers(/:id)(/:tab)/:secId/variation/:varSecId(/:reload)': 'showVariationPopup'
    }
  });

  var API = {
    showVariationPopup: function(id, tab, secId, varSecId, reload) {
      require([
        'customersShowController',
        'customersListController',
        'contentShowController'
      ], function(
          ShowController,
          ListController,
          ContentShowController
      ) {
        ContentShowController.showContent().done(function() {
          var data;
          data = {
            id: id,
            tab: _.findWhere(CustomersTabs, {name: tab}),
            secId: secId,
            varSecId: varSecId,
            type: 'customer',
            reload: reload === 'reload'
          };
          App.startSubModule('customersMain');
          if (id) {
            ShowController.fetchCustomer(data);
          } else {
            ListController.showCustomersList();
          }

          App.execute('set:active:nav:item', ItemPagesNameMixin.MY_CLIENTS);
        });
      });
    },

    showView: function(id, tab, secId, reload) {
      require([
        'customersShowController',
        'customersListController',
        'contentShowController'
      ], function(
        ShowController,
        ListController,
        ContentShowController
      ) {
        ContentShowController.showContent().done(function() {
          var data;
          if (secId === 'reload') {
            data = {
              id: id,
              tab:  _.findWhere(CustomersTabs, {name: tab}),
              type: 'customer',
              reload: true
            };
          } else {
            data = {
              id: id,
              tab: _.findWhere(CustomersTabs, {name: tab}),
              secId: secId,
              type: 'customer',
              reload: reload !== null
            };
          }
          App.startSubModule('customersMain');
          if (id) {
            ShowController.fetchCustomer(data);
          } else {
            ListController.showCustomersList();
          }
          
          App.execute('set:active:nav:item', ItemPagesNameMixin.MY_CLIENTS);
        });
      });
    },

    showContactsDetailsShow: function(id, contactSecId, contactSubTab) {
      require([
        'customerContactsDetailsController',
        'contentShowController',
        'customersContactsInfoTabController'
      ], function(
        DetailsShowController,
        ContentShowController,
        InfoTabController
      ) {
        var mainRegion;

        ContentShowController.showContent().done(function() {
          mainRegion = App.regions.getRegion('main').currentView.getRegion('content');
          DetailsShowController.showTabsLayout(id, mainRegion, contactSubTab, contactSecId).done(function(region, model) {
            InfoTabController.showInfoTab(region, model);
            App.execute('set:active:nav:item', ItemPagesNameMixin.MY_CLIENTS);
          });
        });
      });
    }
  };

  App.on('customers:show', function(id, tab) {
    var linkId = id ? '/' + id : '',
      tabLink = tab ? '/' + tab : '';

    App.navigate('customers' + linkId + tabLink);
    API.showView(id, tab);
  });

  App.on('before:start', function() {
    new CustomersRouter({
      controller: API
    });
  });

  module.exports = CustomersRouter;
});
